import React, { useState } from 'react'
import './ViewCallDetailsStyle.css'
// import CallRecordpopup from '../../CallRecordpopup/CallRecordpopup'
import Progressbar from '../../ProgressBar/Progressbar';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const MnViewcallds = ({ isActive, menteeFeedback, mentorFeedback, callInfo, handleClose }) => {

    const navigate = useNavigate();
    return (
        <div className={`popupWrapper poupviewtab  ${isActive && "active"}`}>
            <div className={`popupContainer poupCDcontainer`}>
                <div className="popupBody DscallAdbody">
                    <span className="closebtn mb10">
                        <img src="/assets/svg/close.svg" alt="" onClick={handleClose} />
                    </span>
                    <div className="headingpoup">
                        <h3>Call Details</h3>
                    </div>

                    <div className=" Adwrapperdetails">
                        <div className="HeaderCallDetailsFaq">
                            <p className='text2'>
                                Agenda:
                                <span className='boldtext ml4'>{callInfo?.agenda ? callInfo?.agenda : "---"}</span>
                            </p>
                        </div>
                        <div className='AgendapopupCallhistory'>
                            <div className='AnswerFaq  AnsForNewFaqUsers'>
                                <div className="answerFaqnew dataVwbackmain">
                                    <ul>
                                        <li>
                                            <div className="profileHistoryDeatils f-items-center">
                                                <div className="userpopupimg">
                                                    <img src={callInfo?.mentee?.profileImg ? callInfo?.mentee?.profileImg : "/assets/img/User.png"} alt='' onClick={() => { navigate(`/mentee/mentee-profile/${callInfo?.mentee?.id}`) }} />
                                                </div>
                                                <div className="CallDetailsNameData flex">
                                                    <div className="NameDetails">
                                                        <h3 className='namelink pointer' onClick={() => { navigate(`/mentee/mentee-profile/${callInfo?.mentee?.id}`) }}>{callInfo?.mentee?.firstName ? `${callInfo?.mentee?.firstName} ${callInfo?.mentee?.lastName}` : "---"}</h3>
                                                        <p className="text2 capitilize">{callInfo?.mentee?.profession?.title ? callInfo?.mentee?.profession?.title === "student" ? 'Student' : 'Working Professional' : "---"}</p>
                                                    </div>
                                                    <span className='Menteespan Designspan'>Mentee</span>
                                                </div>
                                            </div>
                                        </li>

                                    </ul>
                                    <ul className='listVWlistdata listitemscdmaindiv'>
                                        <li> <span>Date: </span>{callInfo?.startTime ? moment(callInfo?.startTime).utcOffset("-00:00").format("DD MMMM, YYYY") : "---"}</li>
                                        {(callInfo?.meetingStatus === "cancelled" || callInfo?.meetingStatus === "rescheduled") && 
                                        <>
                                        <li><span>Reason: </span>{callInfo?.cancelReason}</li>
                                        <li><span className='capitilize'>{callInfo?.meetingStatus} by: </span>{callInfo?.cancelledBy === "Mentor" ? "Self" : callInfo?.cancelledBy}</li>
                                        </>
                                        }
                                        {callInfo?.meetingStatus === "completed" && <>
                                        <li> <span>Call Duration: </span>{callInfo?.callDuration ? (callInfo?.callDuration / 60).toFixed(0) + " min" : "---" }</li>
                                        <li> <span>Call Start time: </span>{callInfo?.startedAt ? moment(callInfo?.startedAt).format("hh:mm a") : "---"}</li>
                                        <li> <span>Call End time: </span>{callInfo?.endedAt ? moment(callInfo?.endedAt).format("hh:mm a") : "---"}</li>
                                        <li> <span>Call Started by:</span>{callInfo?.startedBy ? callInfo?.startedBy : "---"}</li>
                                        <li> <span>Call Ended by: </span>{callInfo?.endedBy ? callInfo?.endedBy : "---"}</li>
                                        </>}
                                        {callInfo?.meetingStatus === "pending" && 
                                            <li><span className='capitilize'>Mentee: </span>{callInfo?.isMenteeJoined ? "Joined": "No Show"}</li>
                                        }
                                        <li className='flex'> <span>Status:</span>
                                            <p className={`conptext ${callInfo?.meetingStatus === "pending" ? 'noshow' : callInfo?.meetingStatus} capitilize ml4`}>{callInfo?.meetingStatus ? callInfo?.meetingStatus === "pending" ? 'No Show' : callInfo?.meetingStatus : "---"}</p>
                                        </li>
                                    </ul>
                                </div>

                                


                                {/* <div className="lodeemorebutton mt10">
                                    <Button name={'Give Feedback'} className={'BlueFillButton buttontext'} />
                                </div> */}

                                {callInfo?.meetingStatus === "completed" && 
                                <>
                                <div className="dottedbr mb-20"></div>
                                <div className='mntorsFeedbackdata'>
                                    <h3 className='heading-3'>Feedback Given</h3>

                                    <div className={`Fbackactivetab mt-10`}>
                                    {mentorFeedback && Object?.keys(mentorFeedback).length > 0 ? <div className={`ProgressQuestionCallhistory`}>
                                            <div className="QuestionProgressbarPop">
                                                <h3>How was your experience with the Mentee?</h3>
                                                <Progressbar count={mentorFeedback?.answer1 ?? 0} />
                                            </div>
                                            <div className="QuestionProgressbarPop">
                                                <h3>What was the mentee’s problem about?</h3>
                                                <p className="text2 capitilize">{mentorFeedback?.answer2 ? mentorFeedback?.answer2 : "---"}</p>
                                            </div>
                                            <div className="QuestionProgressbarPop">
                                                <h3>Were you able to come up with an action plan for the mentee?</h3>
                                                <p className="text2 capitilize">{mentorFeedback?.answer3 ? mentorFeedback?.answer3 : "---"}</p>
                                            </div>

                                            <div className="QuestionProgressbarPop">
                                                <h3>How would you rate the mentee’s employability, if you were to hire them for your own team?</h3>
                                                <Progressbar count={mentorFeedback?.answer4 ?? 0} />
                                            </div>
                                        </div> : "No Feedback given"}
                                    </div>
                                </div>
                                </>
                                }

                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default MnViewcallds